import { Link } from 'react-router-dom';
import { useLegalVisible } from '../hooks/useLegalVisible';

const LINKS = [
  { slug: 'mentions-legales', label: 'Mentions légales' },
  { slug: 'cgv', label: 'CGV' },
  { slug: 'confidentialite', label: 'Confidentialité' },
  { slug: 'cookies', label: 'Cookies' },
  { slug: 'reglement-interieur', label: 'Règlement intérieur' },
  { slug: 'retractation', label: 'Rétractation' },
];

export const LegalFooter = () => {
  const { visible } = useLegalVisible();
  if (!visible) return null;
  return (
  <div className="bg-[#F0E8D9] border-t border-[#E9DDCC] py-4 px-5" data-testid="legal-footer">
    <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5">
      {LINKS.map(l => (
        <Link key={l.slug} to={`/legal/${l.slug}`} className="text-[11px] text-[#AE9885] hover:text-[#9A744C] transition-colors tracking-wide" data-testid={`legal-link-${l.slug}`}>
          {l.label}
        </Link>
      ))}
    </div>
  </div>
  );
};
